import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteVenueOpeningTime = (venueId: string, openingTimeId: string): Promise<any> => {
  return fetch(`${API_URL}/venues/${venueId}/schedule/${openingTimeId}`, {
    method: 'DELETE',
  });
};
